<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-welltect-login></app-welltect-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-welltect-register></app-welltect-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-welltect-forgot-password></app-welltect-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-welltect-change-password-sent></app-welltect-change-password-sent>
  </div>

  <app-welltect-register-resend
    *ngIf="page === 'register-resend'"
  ></app-welltect-register-resend>
</ng-container>
